'use strict'

import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'

// These pages are now hijacked by Akamai so can't be a part of the SPA
const noLongerHelpLinks = [
  '/help/nectar/',
  '/help/argos-care/',
  '/help/product-care/',
  '/help/breakdown-care/',
  '/help/monthly-care/',
  '/help/replacement-care/',
  '/help/jewellery-watch-care/',
  '/help/furniture-care/',
  '/help/argos-card/',
  '/help/argos-card/manage',
  '/help/argos-card/credit-offers/',
  '/help/gift-cards/'
]

class HelpLink extends React.Component {
  render () {
    const { href, children } = this.props

    if (href.indexOf('/help/') === 0 && noLongerHelpLinks.indexOf(href) < 0) {
      return <Link {...this.props} to={href}>{children}</Link>
    } else {
      return <a {...this.props} to={href}>{children}</a>
    }
  }
}

HelpLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  href: PropTypes.string,
  'data-test': PropTypes.string
}

export default HelpLink
